import React, { useCallback, useMemo } from "react";
import { idX } from "@insightfulscience/shared-utils/fn";
import context from "./context";

let deprecationWarning = () => {
	// eslint-disable-next-line no-console
	console.warn('useData hook is deprecated. Use "usePageData instead."');
	deprecationWarning = () => {};
};

export const usePageData = (selector = idX) => selector(React.useContext(context).data);

export const useData = selector => {
	deprecationWarning();
	return usePageData(selector);
};

export const useRun = action => {
	const { run } = React.useContext(context);
	return useCallback((...args) => run(action(...args)), [action, run]);
};

export const useExec = (thunk, deps) => {
	const { run } = React.useContext(context);
	return useMemo(() => run(thunk), deps);
};
